import React from 'react';
import { AssistantIcon } from '../AssistantIcon';
import styles from './aiLabel.scss';
import { StatusBadge } from '@xo-union/tk-component-badges';

export interface AiLabelProps {
  titleText?: string;
}

export function AiLabel({ titleText = 'Quinn' }: AiLabelProps): JSX.Element {
  return (
    <div className={styles.aiLabel}>
      <AssistantIcon />
      {titleText}
      <StatusBadge appearance="info" size="sm">
        BETA
      </StatusBadge>
    </div>
  );
}
